module.exports = {
    en: {
        mainsld: {
            suv: 'SUV',
            sedan: 'Sedan',
            hatchback: "Hatckback",
            coupe: "Coupe",
            hybrid: "Hybrid",
            tag1: "MCTrans – Leader in Auto Import from USA to Georgia",
            title: "Choose a car from America with the help of our experienced experts and American partners. Pay only 30% of the vehicle price and receive 70% co-financing at 0%. Take advantage of transparent service that will be by your side from car purchase to delivery at the car lot of MCTrans.",
            inventory: "Send request",
            contact: "Contact Us",
            tag2: "Or Browse Featured Model",
        }
    },
    ka: {
        mainsld: {
           suv: 'ჯიპი',
            sedan: 'სედანი',
            hatchback: "ჰეჩბეკი",
            coupe: "კუპე",
            hybrid: "ჰიბრიდული",
            tag1: "MCTrans – ავტოიმპორტის ლიდერი ამერიკიდან საქართველოში",
            title: "შეარჩიე ავტომობილი ამერიკიდან ჩვენი გამოცდილი ექსპერტებისა და ამერიკელი პარტნიორების დახმარებით, გადაიხადე ავტომობილის ღირებულების მხოლოდ 30 % და მიიღე 70%-იანი თანადაფინანსება 0%-ად. ისარგებლე გამჭვირვალე მომსახურებით, რომელიც მანქანის შეძენიდან MCTrans-ის ავტოპარკამდე შენს გვერდით იქნება.",
            inventory: "ინვენტარის ნახვა",
            contact: "დაგვიკავშირდით",
            tag2: "შეარჩიე სასურველი მოდელი: ",
        }
    },
    ru: {
        mainsld: {
            suv: 'Джип',
            sedan: 'седан',
            hatchback: "хэтчбек",
            coupe: "купе",
            hybrid: "гибридный",
            tag1: "MCTrans – Лидер автоимпорта из Америки в Грузию",
            title: "Выберите автомобиль из Америки с помощью наших опытных экспертов и американских партнёров. Оплатите всего 30% от стоимости автомобиля и получите 70% софинансирования под 0%. Воспользуйтесь прозрачным сервисом, который будет сопровождать вас с момента покупки автомобиля в автопарке MCTrans.",
            inventory: "Посмотреть инвентарь",
            contact: "Связаться с нами",
            tag2: "Выберите желаемую модель:",
        }
    }
}